import AppLink from '@/components/common/AppLink';
import styles from './styles.module.css';

export interface Crumb {
  label: string;
  to?: string | undefined;
  className?: string;
}

/** Home › Section › Current breadcrumb trail for page heroes. */
export function Breadcrumb({
  items,
  center,
  className,
  position = 'normal',
  currentStyle = '',
  page,
}: {
  items: Crumb[];
  center?: boolean;
  className?: string;
  position?: 'center' | 'normal';
  currentStyle?: string;
  page?: string;
}) {
  return (
    <div
      className={`${styles.crumbs} ${position == 'center' && styles.centerCrumbs} ${page == 'dashboard' && styles.dashboardBreadcrumb} ${className}`}
      data-center={center}
    >
      {items?.map((c, i) => {
        const last = i === items.length - 1;
        return (
          <span key={i} className={styles.item}>
            {c?.to && !last ? (
              <AppLink href={c?.to} title={c?.label} className={styles.link}>
                {c?.label}
              </AppLink>
            ) : (
              <span className={last ? `${styles.current} ${currentStyle}` : styles.link}>
                {c?.label}
              </span>
            )}
            {!last ? <span className={styles.sep}>›</span> : null}
          </span>
        );
      })}
    </div>
  );
}
